// Tên web (nhớ đổi cả <title> trong public/index.html)
export const SITE_NAME = 'Kợt Nhả Decor';

// Địa chỉ công khai của web, dùng để tạo link trong mã QR.
// KHÔNG dùng localhost/192.168... vì người khác quét sẽ không mở được.
// Khi có tên miền thật thì đổi ở đây rồi tải lại QR (mã trong link vẫn giữ nguyên).
export const PUBLIC_SITE_URL = 'https://draw-fe-omega.vercel.app';

export function qrLink(qrToken) {
  return `${PUBLIC_SITE_URL}/qr/${qrToken}`;
}

// Tên miền riêng của trang KAI: vào kairepaint.com là thấy thẳng trang Kai (link không có /kai).
// Bên trong app vẫn dùng đường dẫn /kai/..., chỉ đổi khi đọc/ghi thanh địa chỉ.
export const KAI_HOST = /(^|\.)kairepaint\.com$/.test(window.location.hostname);

// Đường dẫn trong app -> đường dẫn hiện trên thanh địa chỉ (vd /kai/album/5 -> /album/5 trên kairepaint.com)
export function toBrowserPath(appPath) {
  if (!KAI_HOST) return appPath;
  const stripped = appPath.replace(/^\/kai(?=\/|\?|$)/, '');
  return stripped.startsWith('/') ? stripped : '/' + stripped;
}

// Đường dẫn trên thanh địa chỉ -> đường dẫn trong app
export function toAppPath(browserPath) {
  return KAI_HOST ? '/kai' + (browserPath === '/' ? '' : browserPath) : browserPath;
}
